import { Route, Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import CandidateDuplicateScanContext from './CandidateDuplicateScanContext';
import CandidateDuplicateScanProcessPage from './createupdate/CandidateDuplicateScanProcessPage';
import { createRoute } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';

const useCandidateDuplicateScanRoute = () => {
  const routes = createRoute({ listRoute: '/candidates/duplicate-scan' });
  return {
    processRoute: `${routes.singleEntityRoute}`,
  };
};

const CandidateDuplicateScanRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { processRoute } = useCandidateDuplicateScanRoute();

  return (
    <ProtectedRouter basePath="/candidates/duplicate-scan">
      <Routes>
        <Route
          path={processRoute}
          element={
            <CandidateDuplicateScanContext permissionToCheck="READ">
              <CandidateDuplicateScanProcessPage />
            </CandidateDuplicateScanContext>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

CandidateDuplicateScanRouter.getRouterPath = () => `/candidates/duplicate-scan/*`;

export default CandidateDuplicateScanRouter;
